import React, { useEffect, useState, useRef } from "react";
import "../styles/Home.css";
import HeroImg from "../assets/photos/hero-img.png";
import SmartImg from "../assets/photos/smart-section.png";
import BannerImg from "../assets/photos/banner3.png";
import Suvasene from "../assets/photos/suvasene.png";
// Slide 2: replace this import with your actual loan image when ready
import LoanImg from "../assets/photos/loansbanner2.png";
import Banner4Img from "../assets/photos/banner6.png"; // your new slide 4 image
import Banner5Img from "../assets/photos/banner5.png"; // your new slide 5 image

import { FaPiggyBank, FaMoneyBillWave, FaCreditCard } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import ATMWarningPopup from "./ATMWarningPopup";

const SLIDE_DURATION = 3000;

const Home = () => {
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleItem = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    // ── Hero slider state ──
    const [heroSlide, setHeroSlide]         = useState(0);
    const [heroAnimating, setHeroAnimating] = useState(false);
    const [heroDir, setHeroDir]             = useState("next");
    const heroTimer = useRef(null);

    function goToSlide(idx, dir = "next") {
        if (heroAnimating || idx === heroSlide) return;
        setHeroDir(dir);
        setHeroAnimating(true);
        setTimeout(() => {
            setHeroSlide(idx);
            setHeroAnimating(false);
        }, 500);
    }

    function scheduleHero(current) {
        clearTimeout(heroTimer.current);
        heroTimer.current = setTimeout(() => {
            const next = (current + 1) % 5;
            goToSlide(next, "next");
        }, SLIDE_DURATION);
    }

    useEffect(() => {
        scheduleHero(heroSlide);
        return () => clearTimeout(heroTimer.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [heroSlide]);

    // ── Existing intersection observer (untouched) ──
    useEffect(() => {
        const elements = document.querySelectorAll(".fade-in, .slide-up");
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("visible");
                    }
                });
            },
            { threshold: 0.2 }
        );
        elements.forEach((el) => observer.observe(el));
        return () => observer.disconnect();
    }, []);

    const newsItems = [
        {
            title: "RBI Cautions Digital Lending: Balancing Growth with Governance",
            link: "https://www.whalesbook.com/news/English/bankingfinance/RBI-Cautions-Digital-Lending-Balancing-Growth-with-Governance/69b017375b1fc118c08e914e",
            source: "Whalesbook",
            published: "10 March"
        },
        {
            title: "RBI caps small-value digital fraud claims at ₹50,000; banks must prove customer liability.",
            link: "https://economictimes.indiatimes.com/industry/banking/finance/banking/rbi-caps-claims-for-small-value-digital-frauds-at-rs-50000-banks-to-prove-customer-liability/articleshow/129156718.cms",
            source: "Economic Times",
            published: "7 March"
        },
        {
            title: "Rupee falls 13 paise to 91.94 against the dollar as markets keep close watch on crude prices.",
            link: "https://www.moneycontrol.com/news/business/markets/rupee-falls-14-paise-to-91-94-against-the-dollar-all-eyes-on-crude-prices-13856659.html",
            source: "Money Control",
            published: "11 March"
        },
        {
            title: "RBI likely steps in to support rupee after oil price spike pushes it towards a record low.",
            link: "https://www.thehindubusinessline.com/markets/forex/rbi-likely-steps-in-after-oil-spike-pushes-rupee-towards-record-low/article70733776.ece",
            source: "The Hindu",
            published: "12 March"
        }
    ];

    const handleServiceClick = (path) => {
        navigate(path);
    };

    return (
        <main className="home-container">
            <ATMWarningPopup />

            {/* ══════════════════════════════
                HERO SECTION — 3 slides
            ══════════════════════════════ */}
            <section className="hero-section fade-in">

                {/* ── SLIDE 1: Original hero (unchanged) ── */}
                <div className={`hero-slide ${heroSlide === 0 ? "hero-slide--active" : "hero-slide--hidden"} ${heroAnimating && heroSlide === 0 ? `hero-slide--exit-${heroDir}` : ""}`}>
                    <div className="hero-text">
                        <h1 className="hero-title">Welcome to The Sahyadri Sahakari Bank Ltd</h1>
                        <p>Strength in Unity, Banking with Dignity</p>
                        <a href="#features-section-home">
                            <button className="cta-btn">Get Started</button>
                        </a>
                    </div>
                    <div className="hero-image">
                        <img src={HeroImg} alt="Banking" />
                    </div>
                </div>

                {/* ── SLIDE 2: Loans Made Simple ── */}
                <div className={`hero-slide ${heroSlide === 1 ? "hero-slide--active" : "hero-slide--hidden"} ${heroAnimating && heroSlide === 1 ? `hero-slide--exit-${heroDir}` : ""}`}>
                    <div className="hero-text">
                        <span className="hero-badge">Loans</span>
                        <h1 className="hero-title">Every Loan You Need, All in One Place</h1>
                        <p>Home • Personal • Business • Gold — flexible options for every need.</p>
                        <a href="/loans">
                            <button className="cta-btn">Apply Now</button>
                        </a>
                    </div>
                    <div className="hero-image">
                        <img src={LoanImg} alt="Loans" />

                    </div>
                </div>

                {/* ── SLIDE 3: Suvasini Gharkul Yojana ── */}
                <div className={`hero-slide ${heroSlide === 2 ? "hero-slide--active" : "hero-slide--hidden"} ${heroAnimating && heroSlide === 2 ? `hero-slide--exit-${heroDir}` : ""}`}>
                    <div className="hero-text">
                        <span className="hero-badge suvasini-badge">🏠 Only For Women</span>
                        <h1 className="hero-title suvasini-title">Suvasini Home Scheme</h1>
                        <p className="suvasini-sub">Special Home Loan Scheme for Women</p>
                        <p className="suvasini-body">Low interest rate, fast process, a trustworthy companion for your dream home</p>
                        <a href="/schemes">
                            <button className="cta-btn suvasini-btn">Apply Now</button>
                        </a>
                    </div>
                    <div className="hero-image suvasini-image-area">
                        {/* Add your woman+keys image here when ready */}
                        {/* <img src={SuvasiniImg} alt="Suvasini Gharkul Yojana" /> */}
                            <div className="suvasini-placeholder__text"><img src={Suvasene} alt="Suvasini Gharkul Yojana" /></div>
                    </div>
                </div>


                {/* ── SLIDE 4: Banner 4 ── */}
                <div className={`hero-slide ${heroSlide === 3 ? "hero-slide--active" : "hero-slide--hidden"} ${heroAnimating && heroSlide === 3 ? `hero-slide--exit-${heroDir}` : ""}`}>
                    <div className="hero-text slide4-text">
                        <span className="hero-badge">RBI Financial Awarness</span>
                        <h1 className="hero-title">Beware of Digital Arrest Scam.</h1>
                        <p>No Govt. Official Will Demand Money Over Call! Report scam: 1930</p>
                        {/* AFTER — correct */}
                        <a href="https://cybercrime.gov.in" target="_blank" rel="noopener noreferrer">
                            <button className="cta-btn">Report Cyber Crime</button>
                        </a>
                    </div>
                    <div className="hero-image-new slide4-image">
                        <img src={Banner4Img} alt="Banner 4" />
                    </div>
                </div>

                {/* ── SLIDE 5: Banner 5 ── */}
                <div className={`hero-slide ${heroSlide === 4 ? "hero-slide--active" : "hero-slide--hidden"} ${heroAnimating && heroSlide === 4 ? `hero-slide--exit-${heroDir}` : ""}`}>
                    <div className="hero-text">
                        <span className="hero-badge">RBI SCHEME</span>
                        <h1 className="hero-title">RBI - Integrated Ombudsman Scheme</h1>
                        <p>One Nation, One Ombudsman.</p>
                        <a href="/forms/RBI_IOS_Full_Pg_English.pdf">
                            <button className="cta-btn">Know More</button>
                        </a>
                    </div>
                    <div className="hero-image-new slide5-image">
                        <img src={Banner5Img} alt="Banner 5" />
                    </div>
                </div>



                {/* ── Dot navigation ── */}
                <div className="hero-dots">
                    {[0, 1, 2 , 3, 4].map((i) => (
                        <button
                            key={i}
                            className={`hero-dot${heroSlide === i ? " hero-dot--active" : ""}`}
                            onClick={() => {
                                clearTimeout(heroTimer.current);
                                goToSlide(i, i > heroSlide ? "next" : "prev");
                            }}
                            aria-label={`Slide ${i + 1}`}
                        />
                    ))}
                </div>

            </section>
            {/* ══ END HERO SECTION ══ */}

            <section className="smart-banking-section">
                <div className="smart-container">

                    {/* LEFT IMAGE */}
                    <div className="smart-image">
                        <img src={SmartImg} alt="Smart Banking" />
                    </div>

                    {/* RIGHT CONTENT */}
                    <div className="smart-content">

                        <span className="smart-tag">Ways to Bank</span>

                        <h2>Multiple ways of managing your finance</h2>

                        <p>
                            Bank anytime, anywhere with our multiple banking options.
                        </p>

                        <div className="smart-accordion">
                            {[
                                "Branch Banking",
                                "ATM Banking",
                                "SMS Banking",
                                "Mobile Banking",
                                "UPI",
                            ].map((item, index) => (
                                <div
                                    key={index}
                                    className={`smart-item ${activeIndex === index ? "active" : ""}`}
                                    onClick={() => toggleItem(index)}
                                >
                                    <div className="smart-header">{item}</div>

                                    {activeIndex === index && (
                                        <div className="smart-body">
                                            <p>
                                                        {item === "Branch Banking" && "Experience personalized banking services by visiting your nearest branch, where our staff is ready to assist you with all your financial needs."}
                                                        {item === "ATM Banking" && "Access your account anytime through our wide network of ATMs for convenient cash withdrawals, balance inquiries, and more."}
                                                        {item === "SMS Banking" && "Stay informed with real-time updates on your account activities through instant SMS notifications."}
                                                        {item === "Mobile Banking" && "Access your bank anytime, anywhere through our secure mobile banking application, allowing you to check balances, view transaction history, and manage your account with ease."}
                                                        {item === "UPI" && "Transfer funds instantly and make secure digital payments with our fast and reliable UPI platform."}
                                                    </p>

                                                    <button
                                                        className="smart-btn"
                                                        onClick={() => {
                                                            if (item === "Branch Banking") navigate("/branch-banking");
                                                            if (item === "ATM Banking") navigate("/atm-banking");
                                                            if (item === "SMS Banking") navigate("/sms-banking");
                                                            if (item === "Mobile Banking") navigate("/mobile-banking");
                                                            if (item === "UPI") navigate("/upi");
                                                        }}
                                                    >
                                                        Explore More
                                                    </button>
                                        </div>

                                    )}

                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </section>

            <section className="features-section-home" id="features-section-home">
                <h2 className="fade-in">Our Services</h2>

                <div className="features-grid-home">

                    <div
                        className="feature-card slide-up clickable-card"
                        onClick={() => handleServiceClick("/savings")}
                    >
                        <FaPiggyBank size={60} color="#F18B3AFF"/>
                        <h3>Create Account</h3>
                        <p>Create your Savings or Current Account with us.</p>
                    </div>

                    <div
                        className="feature-card slide-up clickable-card"
                        onClick={() => handleServiceClick("/loans")}
                    >
                        <FaMoneyBillWave size={60} color="#F18B3AFF"/>
                        <h3>Loans</h3>
                        <p>Flexible loan options for your personal and business needs.</p>
                    </div>

                    <div
                        className="feature-card slide-up clickable-card"
                        onClick={() => handleServiceClick("/cards-page")}
                    >
                        <FaCreditCard size={60} color="#F18B3AFF"/>
                        <h3>Debit & Credit Cards</h3>
                        <p>Smart cards with rewards and secure transactions.</p>
                    </div>

                </div>
            </section>

            <section className="stats-section fade-in">
                <h2>Our Impact</h2>

                <div className="stats-grid">
                    <div className="stat-card slide-up">
                        <h3>50K+</h3>
                        <p>Happy Customers</p>
                    </div>

                    <div className="stat-card slide-up">
                        <h3>8</h3>
                        <p>Branches</p>
                    </div>

                    <div className="stat-card slide-up">
                        <h3>200K+</h3>
                        <p>Transactions Monthly</p>
                    </div>
                </div>
            </section>

            <section className="testimonials-section fade-in">
                <h2>What Our Customers Say</h2>

                <div className="testimonials-grid">
                    <div className="testimonial-card slide-up">
                        <p>"Trustworthy bank with very professional and helpful staff at every step!."</p>
                        <h4>- A.P. Kulkarni.</h4>
                    </div>

                    <div className="testimonial-card slide-up">
                        <p>"Great customer service and flexible loan options with complete transparency!."</p>
                        <h4>- R.K. Sharma.</h4>
                    </div>

                    <div className="testimonial-card slide-up">
                        <p>"Friendly staff and hassle-free account management make banking enjoyable."</p>
                        <h4>- S.T. Deshmukh.</h4>
                    </div>

                    <div className="testimonial-card slide-up">
                        <p>"Fast loan approvals and transparent processes give me full confidence."</p>
                        <h4>- A.B. Patel.</h4>
                    </div>
                </div>
            </section>

            <section className="banner" id="banner-section">
                <div className="banner-image">
                    <img src={BannerImg} alt="BannerImg"/>
                </div>
                <div className="banner-content">
                    <h1>Open Your Account Today</h1>
                    <p>The Sahyadri Sahakari Bank Ltd</p>
                    <Link to="/savings"><button className="cta-btn-1">Open Account Now</button></Link>
                </div>
            </section>

            <section className="news-section fade-in">
                <h2>Latest RBI & Banking Sector News</h2>

                <div className="news-cards-container">
                    {newsItems.map((item, idx) => (
                        <div key={idx} className="news-card slide-up">
                            <h3 className="news-title">{item.title}</h3>
                            <p className="news-meta">{item.source} • {item.published}</p>
                            <a href={item.link} className="news-link">Read More</a>
                        </div>
                    ))}
                </div>
            </section>

            <section className="cta-section fade-in">
                <h2>Ready to Start Banking?</h2>
                <p>Join thousands of happy customers today.</p>
                <a href="#banner-section"><button className="cta-btn">Open Account</button></a>
            </section>

        </main>
    );
};

export default Home;